import React from 'react'
import { observer } from 'mobx-react-lite'
import { useHistory } from 'react-router-dom'
import { Instance } from 'mobx-state-tree'

import { useStores } from '@trivie/core'
import { QuizMedalRow } from '@trivie/ui-mobile'
import { AssignedQuiz } from '@trivie/core/src/models/UserQuiz'

export interface SubscriptionQuizzesTabProps {
  contentUserIds: number[]
}

export const SubscriptionQuizzesTab = observer((props: SubscriptionQuizzesTabProps) => {
  const { libraryStore } = useStores()
  const { quizzes } = libraryStore
  const { contentUserIds } = props

  const history = useHistory()

  const goToQuiz = (quiz: Instance<typeof AssignedQuiz>) => {
    if (quiz.subscription_user_id) {
      history.push(
        `/library/quiz/?subscription_user_id=${quiz.metadata.subscription_user_id}&topic_id=${quiz.metadata.topic_id}&quiz_id=${quiz.quiz_id}&path_id=${quiz.metadata.path_id}&content_user_id=${quiz.metadata.content_user_id}`,
      )
    } else {
      history.push(
        `/library/quiz/?assignment_id=${quiz.metadata.assignment_id}&topic_id=${quiz.metadata.topic_id}&quiz_id=${quiz.quiz_id}&path_id=${quiz.metadata.path_id}&content_user_id=${quiz.metadata.content_user_id}`,
      )
    }
  }

  const filteredData = quizzes
    .slice()
    .filter(
      (q) =>
        q.metadata.content_user_id != null && contentUserIds.includes(q.metadata.content_user_id),
    )

  return (
    <div style={{ marginTop: 4 }}>
      {filteredData.map((q) => (
        <QuizMedalRow
          key={`sub-quiz-${q.quiz_id}`}
          parentTopicLocked={false}
          backgroundColor={q.pack_color}
          quiz={q}
          due={q.due_date}
          maxAttempts={q.max_attempts}
          imgSource={q.topic_image}
          isReinforcement={false}
          onPress={() => goToQuiz(q)}
          style={{ marginBottom: 12 }}
        />
      ))}
    </div>
  )
})
